import React, { PureComponent, Fragment } from 'react';

import {
  BarChart,
  Bar,
  Cell,
  Tooltip,
  ResponsiveContainer,
  YAxis,
  XAxis,
  CartesianGrid,
  LabelList
} from 'recharts';

import {
  StandardTooltip,
  CustomizedXAxisTick,
  selectFormat
} from './../../Utils/Utils.js';

import Heading from '../../Elements/Heading';


export default class SnapChatComparison extends PureComponent {
  renderBarChart = (data, type) => {
    return (
      <BarChart data={data.graph} layout="vertical" margin={{ top: 0, right: 45, left: 0, bottom: 0 }} >

        <Tooltip cursor={{ fill: "#eee", opacity: .5 }} content={
          <StandardTooltip
            render={({ data }) => {

              const payload = data(this.props)
              if (payload !== null) {

                return (
                  <div className="standard-tooltip">
                    {
                      Object.keys(payload).map(key => (
                        <Fragment key={key}>
                          <header className="standard-tooltip__header">
                            <span className="standard-tooltip__key-header">
                              Comparison
                          </span>
                          </header>
                          <main className="standard-tooltip__main">
                            <div className="standard-tooltip__item">
                              <span className="standard-tooltip__key">
                                <span className="standard-tooltip__icon" style={{ 'background': '#FA6E57' }}></span>
                                <span className="standard-tooltip__value-header">
                                  {payload[key].payload.name}
                                </span>
                              </span>
                              <span className="standard-tooltip__value">
                                {type === 'time' ? selectFormat('time', payload[key].payload.viewValue) : selectFormat('number', payload[key].payload.value)}
                              </span>
                            </div>
                          </main>
                        </Fragment>
                      ))}
                  </div>
                )
              }
            }} />
        } />
        <XAxis type="number" hide={true} axisLine={false} tickLine={false} mirror={false} dataKey="value" tick={<CustomizedXAxisTick />} />
        <YAxis type="category" axisLine={false} tickLine={false} mirror={false} dataKey="name" width={130} interval={0} />
        <CartesianGrid strokeDasharray="3 3" horizontal={false} stroke={'#FC6D52'} strokeOpacity={.3} />

        <defs>
          <linearGradient id="colorComparisonOrange" x1="0" y1="0" x2="1" y2="0">
            <stop offset="5%" stopColor="#FAA461" stopOpacity={1} />
            <stop offset="95%" stopColor="#FC6D52" stopOpacity={1} />
          </linearGradient>
          <linearGradient id="colorComparisonBlue" x1="0" y1="0" x2="1" y2="0">
            <stop offset="5%" stopColor="#17a2b8" stopOpacity={1} />
            <stop offset="95%" stopColor="#17a2b8" stopOpacity={1} />
          </linearGradient>
        </defs>

        <Bar dataKey="value" fill="url(#colorComparisonBlue)">
          {
            type === 'time'
              ? <LabelList dataKey="viewValue" position="right" formatter={(d) => selectFormat('time', d)} />
              : <LabelList dataKey="value" position="right" formatter={(d) => selectFormat('number', d)} />
          }
          {
            data.graph.map((entry, index) => (
              <Cell key={index} fill={index === 0 ? 'url(#colorComparisonOrange)' : 'url(#colorComparisonBlue)'} />
            ))
          }
        </Bar>
      </BarChart>
    )
  }

  render() {

    const { data, group_name } = this.props;

    const selectTime = data => {
      const t = data.split(':');
      return 60 * (+t[0]) + (+t[1])
    }

    const views = {
      graph: [
        { name: group_name, value: data.data["total_views_story"] },
        { name: "Avg", value: data.data["avg_views"] },
        { name: "Max", value: data.data["max_views"] },
        { name: "Min", value: data.data["min_views"] }
      ]
    };
    const timeViewed = {
      graph: [
        { name: group_name, value: selectTime(data.data["total_time_viewed_story"]), viewValue: data.data["total_time_viewed_story"] },
        { name: "Avg", value: selectTime(data.data["avg_time_viewed"]), viewValue: data.data["avg_time_viewed"] },
        { name: "Max", value: selectTime(data.data["max_time_viewed"]), viewValue: data.data["max_time_viewed"] },
        { name: "Min", value: selectTime(data.data["min_time_viewed"]), viewValue: data.data["min_time_viewed"] }
      ]
    };

    return (
      <div className="row snapchat-comparison">
        <div className="col-sm-12 col-md-6 pr-5 pl-4">
          <Heading size={6}>Avg Views Per Story</Heading>
          <ResponsiveContainer height={158}>
            {this.renderBarChart(views)}
          </ResponsiveContainer>
        </div>
        <div className="col-sm-12 col-md-6 pr-5 pl-4">
          <Heading size={6}>Avg Time Viewed Per Story</Heading>
          <ResponsiveContainer height={158}>
            {this.renderBarChart(timeViewed, 'time')}
          </ResponsiveContainer>
        </div>
      </div>
    );
  }
}